import { SsoProvider } from '../../../services/auth';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path
      d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
      fill="#4285F4"
    />
    <path
      d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"
      fill="#34A853"
    />
    <path
      d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
      fill="#FBBC05"
    />
    <path
      d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
      fill="#EA4335"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
      fill="#1877F2"
    />
  </svg>
);

const PROVIDERS: Record<SsoProvider, { label: string; icon: () => JSX.Element }> = {
  google: { label: 'Google', icon: GoogleIcon },
  facebook: { label: 'Facebook', icon: FacebookIcon }
};

interface SsoButtonProps {
  provider: SsoProvider;
  onClick: () => Promise<void> | void;
  loading: boolean;
  /** Another provider's sign-in is in flight — greyed out, but not the spinner. */
  disabled?: boolean;
}

export const SsoButton: React.FC<SsoButtonProps> = ({ provider, onClick, loading, disabled }) => {
  const { label, icon: Icon } = PROVIDERS[provider];

  return (
    <button
      type="button"
      onClick={() => void onClick()}
      disabled={loading || disabled}
      aria-label={`Continue with ${label}`}
      className="flex h-[52px] w-full items-center justify-center gap-2.5 rounded-[12px] border border-[var(--line)] bg-surface text-[15px] font-semibold text-[var(--ink)] shadow-[0_1px_1px_rgba(16,24,40,.03)] transition hover:border-[var(--line-2)] hover:bg-[var(--sunken)] disabled:cursor-not-allowed disabled:opacity-50"
    >
      {loading ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[var(--ink-3)]" />
          <span>Connecting with {label}...</span>
        </>
      ) : (
        <>
          <Icon />
          Continue with {label}
        </>
      )}
    </button>
  );
};
